import { useEffect, useState } from "react";
import { getFrontYardDetail } from "../../../repository/RealEstateRepository";
import { FrontYardDetail } from "../organism";
import { DefaultPage } from "./";

const links = [
  {
    title: "Home",
    to: "/realestate"
  },
  {
    title: "FrontYard",
    to: "/realestate/frontyard"
  },
  {
    title: "Detail"
  }
];

const FrontYardDetailPage = (props) => {
  const [detail, setDetail] = useState(null);
  const { frontYardId } = props.match.params;

  useEffect(() => {
    getFrontYardDetail({ id: frontYardId }, (data) => setDetail(data));
  }, [frontYardId]);

  return (<>
    <DefaultPage pathname={props.location.pathname} links={links}>
      {detail != null && <FrontYardDetail history={props.history} detail={detail} />}
    </DefaultPage>
  </>);
};

export { FrontYardDetailPage };
